import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading font-black text-primary-400 tracking-tight">
                黑料91
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {siteInfo.description}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2">
              {categories.filter(c => c.slug !== 'all').map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/all"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  最新爆料
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-foreground-500"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-foreground-500"></i>
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-foreground-500"></i>
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 黑料91 - 全网最新黑料曝光合集。本站内容仅供娱乐参考，请自行核实信息真实性。
          </p>
          <div className="flex items-center gap-4">
            <a
              href={siteInfo.socialLinks.weibo}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
            >
              微博
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}